import { Drawer, TextField, Table, TableCell } from '@material-ui/core';
import Select from 'react-select';
import AsyncCreatableSelect from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable';
import styled, { css } from 'styled-components';
import { ElongatedButton, GutterCSS } from 'styles/common';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { getColorFromKey, mobileUpMediaQuery } from 'constants/helper';
import theme from 'constants/theme';

const StyledSelect = ({ ...props }) => <Select menuShouldScrollIntoView={false} {...props} />;
export const MeshSelect = styled(StyledSelect)`
  cursor: pointer;
  margin-bottom: 0.6em;
  z-index: ${(props) => props.zIndex ?? '9'};

  .select__control {
    cursor: pointer;
  }
  .select__option {
    cursor: pointer;
  }
  ${(props) =>
    props.compact &&
    css`
      margin-bottom: 0;
      .select__control {
        min-height: 32px;
      }
      .select__dropdown-indicator {
        padding: 0 5px;
      }
    `};
  ${(props) =>
    props.small &&
    css`
      width: 33%;
      display: inline-block;
      margin: 1% 2% 1% 0;
    `};
  ${(props) =>
    props.mediumLen &&
    css`
      width: 72%;
      display: inline-block;
      margin: 1% 2% 1% 0;
    `};
`;

const StyledCreatableSelect = ({ ...props }) => <CreatableSelect menuShouldScrollIntoView={false} {...props} />;

export const MeshCreatableSelect = styled(StyledCreatableSelect)`
  margin-bottom: 0.6em;
  z-index: 9;
  width: ${(props) => props.width ?? '72%'};
  display: inline-block;
  margin: 1% 2% 1% 0;
`;

const StyledAsyncCreatableSelect = ({ ...props }) => (
  <AsyncCreatableSelect menuShouldScrollIntoView={false} {...props} />
);

export const MeshAsyncCreatableSelect = styled(StyledAsyncCreatableSelect)`
  margin-bottom: 0.6em;
  z-index: 9;
  width: ${(props) => props.width ?? '72%'};
  display: inline-block;
  margin: 1% 2% 1% 0;
`;

export const ErrorSubText = styled.div`
  font-size: 12px;
  margin-top: -0.25em;
  color: red;
  margin-bottom: 1.5em;
  ${(props) =>
    props.center &&
    css`
      text-align: center;
      margin-top: 2em;
    `};
`;

export const HeadingText = styled.div`
  font-size: 24px;
  color: ${getColorFromKey('textPrimary')};
  font-weight: 400;
`;

export const SubHeadingText = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.palette.text.label};
  margin: 0.25em 0 1.25em 0;
`;

export const Container = styled.div`
  width: 100%;
  grid-template-columns: 1.5fr 2fr;
  height: 100vh;
  padding: ${() => (checkNewNavEnabled() ? '0' : '16px')};
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `};
`;

export const FormContainer = styled.div`
  min-height: 70vh;
  background: #ffffff;
  // border: 1px solid #e1e1e1;
  border-radius: 4px;
  padding: 1.75em 2.25em;
  box-shadow: ${(props) => props.theme.palette.shadows.paper};

  ${(props) =>
    props.fullHeight &&
    css`
      min-height: 80vh;
    `};
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `};
`;

export const StyledTextField = styled(TextField)`
  width: 33%;
  margin: 1% 2% 1% 0;
  input {
    background: ${(props) => props.background ?? 'white'};
  }

  ${(props) =>
    props.block &&
    css`
      display: block;
      div {
        width: 100%;
      }
    `};
  ${(props) =>
    props.nomargin &&
    css`
      margin: 0;
    `};
  ${(props) =>
    props.small &&
    css`
      width: 22.5%;
    `};
  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `};
`;

export const ButtonContainer = styled.div`
  padding: 1em 0 2em 0;
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `};
  ${(props) =>
    props.evenPad &&
    css`
      padding: 1em 0;
    `};
  ${(props) =>
    props.bottom &&
    css`
      position: absolute;
      bottom: 1em;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      text-align: center;
    `};
`;

export const TopButtonContainer = styled.div`
  padding: 0.35em 1.25em;
  border: 1px solid #e0edff;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 #cccccc;
  height: 71px;
  margin: 1em 0;
`;

export const ButtonSpacer = styled.div`
  display: inline-block;
  width: 4%;
`;

export const Button = styled(ElongatedButton)`
  height: 40px;
  ${(props) =>
    props.green &&
    css`
      background: linear-gradient(180deg, #5cc461 0%, #1ba522 100%);
      &:disabled {
        opacity: 0.5;
        color: #fff;
      }
    `};
  ${(props) =>
    props.blueOutline &&
    css`
      border: 1px solid ${theme.palette.primary.main};
      color: ${theme.palette.primary.main};
      &:disabled {
        opacity: 0.5;
        border: 0px;
        color: ${theme.palette.primary.main};
      }
    `};
  ${(props) =>
    props.redOutline &&
    css`
      border: 1px solid ${theme.palette.red.main};
      color: ${theme.palette.red.main};
      &:disabled {
        opacity: 0.5;
        color: ${theme.palette.red.main};
      }
    `};
  ${(props) =>
    props.blue &&
    css`
      background: ${theme.palette.primary.main};
      color: #fff;
      &:hover {
        background: ${theme.palette.primary.main};
        color: #fff;
      }
      &:disabled {
        opacity: 0.5;
        color: #fff;
        background-color: #008ef066 !important;
      }
    `};
  ${(props) =>
    props.red &&
    css`
      background: linear-gradient(180deg, #ff3b30 0%, #ff3b30 100%);
    `};
  ${(props) =>
    props.light &&
    css`
      background: linear-gradient(180deg, #f1f1f1 0%, #f1f1f1 100%);
      color: #333;
    `};
  ${(props) =>
    props.fb &&
    css`
      background: linear-gradient(180deg, #3b5998 0%, #3b5998 100%);
    `};
  padding: 0.3rem 3rem;
  margin: 0;
  ${(props) =>
    props.compact &&
    css`
      padding: 0.3rem 1rem;
    `};
  ${(props) =>
    props.table &&
    css`
      padding: 0.2rem 2.5rem;
    `};
  ${(props) =>
    props.tablecompact &&
    css`
      padding: 0.2rem 0.6rem;
    `};
  ${(props) =>
    props.right &&
    css`
      float: right;
      margin-top: 0.75em;
    `};
  ${(props) =>
    props.small &&
    css`
      font-size: 0.75rem;
    `};
`;

export const NoResultsText = styled.div`
  color: #777;
  height: 10em;
  text-align: center;
  line-height: 10em;
  ${(props) =>
    props.fullHeight &&
    css`
      height: 75vh;
      line-height: 75vh;
    `};
`;

export const StyledTable = styled(Table)`
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  // box-shadow: 1px 2px 4px 0 rgba(199, 189, 174, 0.5);
  // border: 1px solid rgba(199, 189, 174, 0.5);
  background: white;
  margin-top: 1.25em;
`;

export const StyledTableHeadCell = styled(TableCell)`
  background: #f6f6f7;
  color: #838489;
  font-size: 14px;
  padding: 5px 40px 5px 16px;
`;

export const StyledTableCell = styled(TableCell)`
  border-bottom: 1px solid #e0edff;
  padding: 9px 40px 9px 16px;
`;

export const StyledDrawer = styled(Drawer)`
  z-index: 999 !important;
  .MuiDrawer-paper {
    width: 100%;
    padding: 0.75em 0.75em;
  }
  ${(props) => props.theme.breakpoints.down('xs')} {
    .MuiDrawer-paper {
      padding: 0;
    }
  }

  ${(props) =>
    props.noScroll &&
    css`
      .MuiDrawer-paper {
        overflow-y: hidden;
      }
    `}
  ${(props) => mobileUpMediaQuery(props.theme)} {
    .MuiDrawer-paper {
      width: 36.5%;
      // using this exact em value in checkins panel footer.
      padding: 0.75em 1.75em;
    }
  }
`;

export const SidebarIcon = styled.a`
  color: #999;
  position: absolute;
  right: 2em;
  top: 1.45em;
  cursor: pointer;
`;

export const Separator = styled.hr`
  border: 0;
  border-bottom: 1px solid #c7bdae;
  margin: 0.75em 0em 1.15em 0em;
  opacity: 0.5;
  ${GutterCSS}
`;

export const LinkIcon = styled.a`
  cursor: pointer;
  color: #323846;
`;

export const ModalContainer = styled(Container)`
  background: white;
  height: 38%;
  width: 32%;
  transform: translate(115%, 60%);
`;

export const AbsoluteCenter = styled.div`
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
`;

export const noMarginSelectStyles = {
  menu: (provided, state) => ({
    ...provided,
    marginTop: 0,
  }),
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: 9,
  }),
  container: (provided) => ({
    ...provided,
    marginTop: '9px',
  }),
};
